/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ServoBikeProductType {
    StandardBikeEbike = 'StandardBikeEbike',
    Diebstahl = 'Diebstahl',
    KompaktPaket = 'KompaktPaket',
    PremiumPaket = 'PremiumPaket'
  }

    export const ServoBikeProductTypeTranslocoMap: Record<ServoBikeProductType, string> = {
    [ServoBikeProductType.StandardBikeEbike]: 'servoBikeProductType.standardBikeEbike',
    [ServoBikeProductType.Diebstahl]: 'servoBikeProductType.diebstahl',
    [ServoBikeProductType.KompaktPaket]: 'servoBikeProductType.kompaktPaket',
    [ServoBikeProductType.PremiumPaket]: 'servoBikeProductType.premiumPaket',
    };

    export const ServoBikeProductTypeOptions = [
  { value: ServoBikeProductType.StandardBikeEbike, labelKey: 'servoBikeProductType.standardBikeEbike' },
  { value: ServoBikeProductType.Diebstahl, labelKey: 'servoBikeProductType.diebstahl' },
  { value: ServoBikeProductType.KompaktPaket, labelKey: 'servoBikeProductType.kompaktPaket' },
  { value: ServoBikeProductType.PremiumPaket, labelKey: 'servoBikeProductType.premiumPaket' },
    ];

